'use client';

import NumberInput from '@/components/NumberInput';
import { useId } from 'react';

export default function Amount({ value, onChange }) {
  const id = useId();

  return (
    <div className='flex flex-col gap-2'>
      <div className='relative'>
        <NumberInput
          id={id}
          className='peer py-6 px-6 text-white amount-input'
          placeholder='0.00'
          value={value}
          onChange={onChange}
        />
        <span className='pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-sm peer-disabled:opacity-50'>
          $
        </span>
      </div>
    </div>
  );
}
